export default "__VITE_ASSET__Bl8c7LC$__"